import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface CloudViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class CloudViewPage extends Component<CloudViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.cloud(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}